"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contributions = void 0;
const Agent_1 = __importDefault(require("./Agent"));
const mutations = __importStar(require("./graphql/mutations"));
const queries = __importStar(require("./graphql/queries"));
const subscriptions = __importStar(require("./graphql/subscriptions"));
const Log_1 = __importDefault(require("../Log"));
const AppSyncConsumer_1 = __importDefault(require("./AppSyncConsumer"));
class Contributions extends AppSyncConsumer_1.default {
    constructor(appSyncClient, environmentId) {
        super(appSyncClient);
        this._observables = new Map();
        this._environmentId = environmentId;
    }
    get observables() {
        return this._observables;
    }
    makeContribution(contribution, agentId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!contribution.type || !contribution.type.length) {
                throw Error('Contribution type cannot be empty');
            }
            const variables = {
                environmentId: this._environmentId,
                type: contribution.type,
                agentId: agentId,
                data: contribution.data ? contribution.data : ''
            };
            Log_1.default.debug('Put contributions request arguments:', variables);
            const response = yield this._client
                .mutate({
                mutation: mutations.putContributionsData,
                variables
            })
                .catch((err) => {
                Log_1.default.error('Failed to make contribution', err);
                throw err;
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.putContributionsData;
        });
    }
    getContributions(type, agentId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!type || !type.length) {
                throw Error('Type cannot be empty');
            }
            if (agentId !== undefined && !agentId.length) {
                throw Error(`Invalid agent id provided`);
            }
            const variables = {
                environmentId: this._environmentId,
                type,
                agentId
            };
            Log_1.default.debug('Get contributions request arguments:', variables);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const response = yield this._client
                .query({
                query: queries.getContributionsData,
                variables,
                fetchPolicy: 'no-cache'
            })
                .catch((err) => {
                Log_1.default.error('Failed to get contributions', err);
                throw err;
            });
            if (agentId) {
                response.data.getContributionsData = response.data.getContributionsData.filter((item) => item.agentId === agentId);
            }
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.getContributionsData;
        });
    }
    getTypesFromContributions(agentId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (agentId !== undefined && !agentId.length) {
                throw Error(`Invalid agentid provided`);
            }
            const variables = {
                environmentId: this._environmentId,
                agentId: agentId
            };
            Log_1.default.debug('Get contributions types list arguments:', variables);
            const response = yield this._client
                .query({
                query: queries.getContributionsDataTypes,
                variables,
                fetchPolicy: 'no-cache'
            })
                .catch((err) => {
                Log_1.default.error('Failed to get contribution types', err);
                throw Error(err);
            });
            // const unique = response.data.getContributionsDataTypes.filter(function (elem, index, self) {
            //   return index === self.indexOf(elem);
            // });
            const types = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.getContributionsDataTypes;
            return new Set(types);
        });
    }
    removeContribution(contribution) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!contribution.id ||
                !contribution.id.length ||
                !contribution.environmentId ||
                !contribution.environmentId.length ||
                !contribution.type ||
                !contribution.type.length) {
                throw Error('id, type and environmentId cannot be empty');
            }
            const variables = {
                id: contribution.id,
                environmentId: contribution.environmentId,
                type: contribution.type
            };
            Log_1.default.debug('Remove contirbutions type arguments:', variables);
            const response = yield this._client
                .mutate({
                mutation: mutations.removeContributionsData,
                variables
            })
                .catch((err) => {
                Log_1.default.error('Failed to remove contribution', err);
                throw err;
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.removeContributionsData;
        });
    }
    removeAllFromContributions(agent) {
        return __awaiter(this, void 0, void 0, function* () {
            if (agent !== undefined && !(agent instanceof Agent_1.default)) {
                throw Error('Invalid agent instance type provided');
            }
            const types = yield this.getTypesFromContributions(agent === null || agent === void 0 ? void 0 : agent.id);
            for (const item of types) {
                const variables = {
                    environmentId: this._environmentId,
                    type: item.type
                };
                Log_1.default.debug('Remove contributions types arguments:', variables);
                yield this._client
                    .mutate({
                    mutation: mutations.removeContributionsData,
                    variables
                })
                    .catch((err) => {
                    Log_1.default.error('Failed to remove contribution', err);
                    throw err;
                });
            }
            return types;
        });
    }
    subscribeToContributions(type, handler, agentId) {
        if (!type || !type.length) {
            throw Error('Key cannot be empty');
        }
        const variables = {
            environmentId: this._environmentId,
            type: type,
            agentId
        };
        Log_1.default.debug('Subscribe to contributions arguments:', variables);
        const obs = this._client.subscribe({ query: subscriptions.contributionsDataUpdated, variables }).subscribe({
            next: ({ data }) => {
                Log_1.default.trace(data);
                const { id, type, agentId, contribution } = data.contributionsDataUpdated;
                handler === null || handler === void 0 ? void 0 : handler({
                    id,
                    type,
                    agentId,
                    contribution,
                    data: data.contributionsDataUpdated.data
                });
            },
            error: ({ error }) => {
                Log_1.default.error('Contribution subscription error', error);
            },
            complete: () => {
                Log_1.default.debug('Contribution subscription complete');
            }
        });
        this._observables.set(JSON.stringify({ type }), obs);
    }
    unsubscribeFromContributions(type) {
        var _a;
        if (!type || !type.length) {
            throw Error('Type cannot be empty');
        }
        Log_1.default.debug('Unsubscribe from contributions arguments:', { type });
        (_a = this._observables.get(JSON.stringify({ type }))) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
exports.Contributions = Contributions;
//# sourceMappingURL=Contributions.js.map